export default "__VITE_ASSET__BiDUEn0f__"